import { NgModule } from '@angular/core';
import { AdcLibComponent } from './adc-lib.component';
import { AdcComponentsModule } from './adc-components/adc-components.module';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';



@NgModule({
  declarations: [
    AdcLibComponent
  ],
  imports: [
    AdcComponentsModule,
    FormsModule,
    CommonModule,
    BrowserModule,
  ],
  exports: [
    AdcLibComponent,
    AdcComponentsModule,
  ]
})
export class AdcLibModule { }
